import { CommonCMS } from "@lib/constants/contentful";

export const serbianLocale = "sr-Latn-RS";
export const serbianMarket = "rs";
export const serbianPhoneCountryCode = "+381";

export const sanitizedSerbianLocale = "sr-RS";

export const isSerbianSignup = (market: string, locale: string) => {
    // serbian signup works only for en-GB locale
    return market === serbianMarket && locale === "en-GB";
};

export const signupMicrocopies = [
    CommonCMS.joinTheClubTitle,
    CommonCMS.signUpDescriptionEccoClub,
    CommonCMS.email,
    CommonCMS.password,
    CommonCMS.passwordRules,
    CommonCMS.firstName,
    CommonCMS.lastName,
    CommonCMS.dateOfBirth,
    CommonCMS.gender.title,
    CommonCMS.gender.male,
    CommonCMS.gender.female,
    CommonCMS.gender.neutral,
    CommonCMS.phone,
    CommonCMS.country,
    CommonCMS.button.createAccount,
    CommonCMS.subscribeCheckbox,
    CommonCMS.error.email,
    CommonCMS.error.dateOfBirth,
    CommonCMS.error.general.title,
    CommonCMS.error.requiredFieldError,
    CommonCMS.error.existingUserAccount,
    CommonCMS.error.existingAccountResetPassword,
    CommonCMS.error.passwordRules,
    CommonCMS.error.phone,
    CommonCMS.createAccountTitle,
];

export const VerifyAccountMicrocopies = [
    CommonCMS.loyalty.accessRewardsSubtitle,
    CommonCMS.loyalty.emailVerification.emailSent,
    CommonCMS.loyalty.emailVerification.failed,
    CommonCMS.loyalty.emailVerification.verifyEmailToGetAccess,
    CommonCMS.loyalty.tierLevel,
    CommonCMS.loyalty.pointsBalance,
    CommonCMS.loyalty.eccoPass,
    CommonCMS.loyalty.membershipId,
    CommonCMS.loyalty.showEccoPass,
    CommonCMS.loyalty.thankYouForJoining,
    CommonCMS.welcomeToEccoClub,
];
